import type { User } from '@sdk/users/types/User';
import ToastComponent from '@sdk/common/toast/ToastComponent';
import Row from '@sdk/components/ui/spacing/Row';
import Spinner from '@sdk/components/ui/Spinner';

import DocumentsList from '@web/users/documents/DocumentsList/DocumentsList';
import DocumentDetails from '@web/users/documents/DocumentDetails/DocumentDetails';
import { useUserDocumentsView } from '@web/users/documents/UserDocumentsView/userDocumentsView.hooks';
import { UserDocumentsContainer } from '@web/users/documents/UserDocumentsView/userDocumentsView.styles';

type Props = {
  user: User;
  documentId: number | string;
  setDocumentIdInPath: (value: number | string | undefined) => void;
  isUserManagedByMe: boolean;
  disabled: boolean;
  disabledOnClick: () => void;
};

const UserDocumentsView = ({
  user,
  documentId,
  setDocumentIdInPath,
  isUserManagedByMe,
  disabled,
  disabledOnClick,
}: Props) => {
  const {
    documentToEdit,
    onEdit,
    onAdd,
    documentsList,
    isListLoading,
    getDocumentsList,
    goBackToList,
  } = useUserDocumentsView(user, documentId, setDocumentIdInPath, disabled);

  if (isListLoading) {
    return (
      <Row mTop={60}>
        <Spinner />
      </Row>
    );
  }

  return (
    <UserDocumentsContainer
      disabled={disabled}
      onClick={() => {
        if (disabled) {
          disabledOnClick();
        }
      }}>
      {documentId ? (
        <DocumentDetails user={user} documentToEdit={documentToEdit} goBackToList={goBackToList} />
      ) : (
        <DocumentsList
          onAdd={onAdd}
          onEdit={onEdit}
          onRemove={getDocumentsList}
          documentsList={documentsList}
          isUserManagedByMe={isUserManagedByMe}
          disabled={disabled}
        />
      )}
      <ToastComponent />
    </UserDocumentsContainer>
  );
};

export default UserDocumentsView;
